import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"
import { kebabCase } from "lodash"
import * as styles from "../../styles/recommenditemscard.module.scss"

const RecommendItemsCard = ({
  slug,
  label = "Recommend Item",
  isSlim = false,
}) => {
  const data = useStaticQuery(graphql`
    query {
      allMdx {
        nodes {
          fields {
            slug
          }
          frontmatter {
            title
            description
            category1
            category2
            hero {
              childImageSharp {
                gatsbyImageData(
                  width: 600
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
    }
  `)

  // スラッシュを除去して完全に一致する記事を探す
  const post = data.allMdx.nodes.find(
    node => node.fields.slug.replace(/\//g, "") === slug.replace(/\//g, "")
  )

  if (!post) return null

  const image = getImage(post.frontmatter.hero)

  return (
    <motion.div
      whileHover={{ x: 5 }}
      className={`${styles.cardWrapper} ${isSlim ? styles.slimCard : ""}`}
    >
      <Link
        to={`/${kebabCase(post.frontmatter.category1)}/${kebabCase(
          post.frontmatter.category2
        )}/${kebabCase(post.fields.slug)}`}
        className={styles.cardLink}
      >
        <div className={styles.imageSide}>
          <GatsbyImage
            image={image}
            alt={post.frontmatter.title}
            className={styles.eyecatch}
          />
          {!isSlim && <div className={styles.label}>{label}</div>}
        </div>

        <div className={styles.contentSide}>
          <div className={styles.meta}>
            {isSlim && <span className={styles.slimLabelBadge}>{label}</span>}
          </div>

          <h3 className={styles.title}>{post.frontmatter.title}</h3>

          {!isSlim && (
            <div className={styles.description}>
              {post.frontmatter.description}
            </div>
          )}
        </div>
      </Link>
    </motion.div>
  )
}

export default RecommendItemsCard
